import * as types from './mutation-types'


export const openSession = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('pos/open/session', data).then((response) => {
      commit(types.UPDATE_SESSION, response.data.session)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const closeSession = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.post('pos/close/session').then((response) => {
      commit(types.UPDATE_SESSION, response.data.session)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}


export const getSession = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('pos/get/session').then((response) => {
      commit(types.UPDATE_SESSION, response.data.session)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const getShopBox = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('pos/get/shopBox').then((response) => {
      commit(types.UPDATE_SHOP_BOX, response.data.shopBox)
      commit(types.ADD_BOXES, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const getSingleSession = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`pos/get/${id}/session`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const productAlertNotification = ({commit, dispatch, state}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/stock/notification/list').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
